import { EDocumentStatus } from '@if/core/types'
import { registerEnumSet } from '@if/mui'
import { CircleCheck, CircleX, Clock, FileUp, Trash2, TriangleAlert } from 'lucide-react'

// Registers each document status (color + icon + enum label) so EnumChip renders it consistently. Load-once at bootstrap.
registerEnumSet(
  EDocumentStatus,
  {
    [EDocumentStatus.AwaitingDocument]: {
      color: 'warning',
      icon: FileUp,
      labelKey: 'EDocumentStatus.awaitingDocument',
    },
    [EDocumentStatus.AwaitingScan]: { color: 'warning', icon: Clock, labelKey: 'EDocumentStatus.awaitingScan' },
    [EDocumentStatus.AwaitingApproval]: { color: 'info', icon: Clock, labelKey: 'EDocumentStatus.awaitingApproval' },
    [EDocumentStatus.Incomplete]: { color: 'warning', icon: TriangleAlert, labelKey: 'EDocumentStatus.incomplete' },
    [EDocumentStatus.Deleted]: { color: 'secondary', icon: Trash2, labelKey: 'EDocumentStatus.deleted' },
    [EDocumentStatus.Refused]: { color: 'error', icon: CircleX, labelKey: 'EDocumentStatus.refused' },
    [EDocumentStatus.Approved]: { color: 'success', icon: CircleCheck, labelKey: 'EDocumentStatus.approved' },
  },
  'enum',
)
